import React from 'react'
import {connect} from 'react-redux'

import {loadSettings, saveSettings} from '../../../../store/Settings/actions/sets/Object'
import {updateOptions} from '../../../../store/Settings/actions'
import {OBJECT_NET, OBJECT_OBJECT} from '../../../../store/Settings/sets'

import ObjectAdvert from './ObjectAdvert'


const ObjectNetContainer = props => (
    <ObjectAdvert
        className={props.className}
        settings={props.settings}
        stateKey={props.stateKey}
        loadSettings={props.loadSettings}
        updateOptions={props.updateOptions}
        saveSettings={props.saveSettings}
    />
)

const stateToProps = (state, { stateKey }) => {
    let settings = state.settings.settings[OBJECT_OBJECT] || {}
    return {
        settings: {...settings[stateKey]},
    }
}

const actionsToProps = {
    loadSettings,
    updateOptions,
    saveSettings,
}

export default connect(stateToProps, actionsToProps)(ObjectNetContainer)